export default {"src":"/_next/static/media/scatterPlotIcon.95133db0.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};